import type { NwsPeriod } from './types'

const sameDay = (iso: string, ref: string) => new Date(iso).toDateString() === ref

/**
 * Today's realized high — the max of today's daytime forecast period, today's remaining
 * hourly temps, and the current observed temp. Never blank once the daytime forecast
 * period has already passed (evening).
 */
export function realizedTodayHigh(
  daily: NwsPeriod[],
  hourly: NwsPeriod[],
  current: number | null,
): number | null {
  const today = new Date().toDateString()
  const c: number[] = []
  for (const p of daily) if (p.isDaytime && sameDay(p.startTime, today)) c.push(p.temperature)
  for (const p of hourly) if (sameDay(p.startTime, today)) c.push(p.temperature)
  if (current != null) c.push(current)
  return c.length ? Math.max(...c) : null
}

/** Today's low — the forecast night period, today's hourly, and the current temp. */
export function realizedTodayLow(
  daily: NwsPeriod[],
  hourly: NwsPeriod[],
  current: number | null,
): number | null {
  const today = new Date().toDateString()
  const c: number[] = []
  for (const p of daily) if (!p.isDaytime && sameDay(p.startTime, today)) c.push(p.temperature)
  for (const p of hourly) if (sameDay(p.startTime, today)) c.push(p.temperature)
  if (current != null) c.push(current)
  return c.length ? Math.min(...c) : null
}
